<template>
  <form
    :class="['d-flex', 'flex-column', 'justify-content-between', (submitting || disabled) ? 'disabled' : '']"
    @submit.prevent="ssoLogin">
    <div>
      <Confirmation
        v-if="showConfirmBox"
        :success="success"
        :message="confirmMsg.message"
        :title="confirmMsg.title"
        class="pb-2"/>
      <LoadingButton
        :disabled="submitting || disabled"
        :loading="submitting"
        button-class="btn-standard mt-0">
        {{ $t('continue') }}
      </LoadingButton>
      <div class="text-center">
        <button
          @click.prevent="$emit('ssoLogout')"
          class="sso-logout btn-secondary">{{ $t('nhst.id.logout') }}</button>
      </div>
    </div>
  </form>
</template>

<script>

import { ajaxForm, closeIconController, formDescriptionHander } from '@mixins';
import LoadingButton from '@components/elements/LoadingButton';
import Confirmation from '@components/elements/Confirmation';
import { EXTERNAL_CONFIGS } from '@root/src/helpers/ExternalConfigs';

export default {
  name: 'sso-login',
  components: { Confirmation, LoadingButton },
  mixins: [ajaxForm, closeIconController, formDescriptionHander],
  computed: {
    confirmMsgs: function () {
      return {
        429: {
          title: '',
          message: this.$t('concurrent.session.exceeded')
        }
      };
    },
  },
  methods: {
    customFormDescriptionHandler() {
      if (isServer) {
        return false;
      }
      this.formHeading = this.$t('sso.log.in.page.title', { email: this.ssoEmail });
      this.formSubHeading = this.$t('sso.log.in.page.description', { email: this.ssoEmail, pubName: this.publication.title });
      return true;
    },
    shouldShowCloseIcon() {
      return this.shouldShowSsoCloseIcon;
    },
    handleCloseIconClicked() {
      this.sendSsoPopupCloseEvent(false);
    },
    async ssoSuccessHandler() {
      this.showConfirmBox = false;
      this.$postMessage.send(
        EXTERNAL_CONFIGS.EVENTS.LOGIN_SUCCESS
      );
      this.closePopupOrRedirectPrevUrl(true);
    },
    ssoErrorHandler() {
      this.updateSsoMeta();
    },
    ssoLogin() {
      const app = this;
      this.submitFormWithHandlers(
        () => app.authServices.ssoLogin(
          this.publication.name,
          this.ssoMeta
        ),
        true,
        app.ssoSuccessHandler,
        app.ssoErrorHandler,
        false,
      );
    }
  }
};
</script>

<style lang="scss">
a.sso-logout {
  font-size: 18px;
}
</style>
